<template>
  <v-card
    min-height="350"
    class="d-flex flex-column justify-center px-3"
    style="background-color: #eee; text-align: center"
  >
    <div class='pb-3' style='padding-top: 50px'>
      <div
        class="d-flex flex-row-reverse justify-space-between"
        style="width: 100%; position: absolute; top: 3px; left: 0"
      >
        <div>
          <v-btn class="ma-1" color="primary" text @click="openTemplate">
            別のテンプレートを使う
          </v-btn>
        </div>
      </div>
      <ButtonItemPreview :item="editingButtonItem" />
    </div>
  </v-card>
</template>

<script>
import ButtonItemPreview from '../previews/ButtonItemPreview'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ButtonItemFormPreview',
  components: { ButtonItemPreview },
  mixins: [formValidationUtils],
  props: {
    itemableAttributes: {
      type: Object,
      required: true
    }
  },
  computed: {
    editingButtonItem () {
      return { itemableAttributes: this.itemableAttributes }
    }
  },
  methods: {
    openTemplate () {
      this.$emit('open-template')
    }
  }
}
</script>
